var cilDoubleQuoteSansLeft = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M232,246.857V16H16V416H54.4ZM48,48H200V233.143L48,377.905Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M280,416h38.4L496,246.857V16H280ZM312,48H464V233.143L312,377.905Z' class='ci-primary'/>"];

export { cilDoubleQuoteSansLeft };
//# sourceMappingURL=cil-double-quote-sans-left.js.map
